import { useMutation } from '@vue/apollo-composable'
import DeleteCustomerSpecialPriceMutation from '../graphql/DeleteCustomerSpecialPriceMutation.graphql'

export const useDeleteCustomerSpecialPrice = () => {
	const {
		mutate: deletePrice,
		loading,
		error,
		onDone,
		onError,
	} = useMutation(DeleteCustomerSpecialPriceMutation)

	const executeDelete = async ({ company_id, customer_id, stock_id }) => {
		try {
			const result = await deletePrice({
				company_id: company_id,
				customer_id,
				stock_id,
			})
			return result
		} catch (err) {
			console.error('Error deleting customer special price:', err)
			throw err
		}
	}

	return {
		executeDelete,
		loading,
		error,
		onDone,
		onError,
	}
}
